import { render, staticRenderFns } from "./vehicledocumentspopup.html?vue&type=template&id=1426bfbf&scoped=true&external"
import script from "./vehicledocumentspopup.vue?vue&type=script&lang=js"
export * from "./vehicledocumentspopup.vue?vue&type=script&lang=js"
import style0 from "./vehicledocumentspopup.vue?vue&type=style&index=0&id=1426bfbf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1426bfbf",
  null
  
)

export default component.exports